import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FaInfoCircle, FaChartLine, FaSearchDollar, FaUniversity, FaCogs, FaLightbulb } from 'react-icons/fa';
import "./investimento.css";
import investimentoImg from "../../assets/finance-7056936_1280.png";
import investimento from "../../assets/growth-7558931_1920.jpg";
import investimentos from "../../assets/money-2724241_1920.jpg";

function Investimento() {
    return (
        <HelmetProvider>
            <Helmet>
                <title>Guia Completo de Investimentos</title>
                <meta name="description" content="Saiba como começar a investir e transformar suas finanças. Guia completo sobre planejamento financeiro, investimentos e estratégias eficazes." />
                <meta name="keywords" content="investimentos, planejamento financeiro, renda fixa, renda variável, Tesouro Direto, CDB, LCI, LCA, ações, fundos imobiliários, criptomoedas, método BEST, Luiz Barsi Filho, educação financeira" />
            </Helmet>

            <div className="blog-container">
                <div className="blog-header">
                    <h1 className="blog-title">Guia Completo de Investimentos</h1>
                    <p>Como Começar e Transformar Suas Finanças</p>
                </div>
               
                <div className="blog-section">
                    <h2 className="section-title"><FaInfoCircle className="icon" /> Introdução</h2>
                    <p>Investir pode parecer um desafio intimidante, especialmente para aqueles que estão começando.
                        No entanto, com o conhecimento certo, você pode transformar suas finanças e garantir um futuro financeiro mais seguro.
                        Neste artigo, vamos explorar os fundamentos dos investimentos e, em seguida, aprofundar no método BEST,
                        uma estratégia eficaz desenvolvida por Luiz Barsi Filho para investidores que buscam estabilidade e crescimento.</p>
                </div>

                <div className="blog-section" id="investment-section">
                    <h2 className="section-title"><FaChartLine className="icon" /> O que é Investimento?</h2>
                    <div className="investment-content">
                        <img src={investimentoImg} alt="regando dinheiro metafora" className="investment-img" />
                        <img src={investimento} alt="bolsa de valores" className="investment-img" />
                        <img src={investimentos} alt="dinheiro crescendo" className="investment-img" />
                        <p>Investimento é o ato de alocar recursos, geralmente dinheiro,
                            em algum ativo financeiro ou negócio com o objetivo de obter um retorno futuro.
                            Existem várias formas de investimentos,
                            e cada uma delas apresenta um nível diferente de risco e potencial de retorno.</p>
                    </div>
                </div>

                <div className="blog-section">
                    <h2 className="section-title"><FaSearchDollar className="icon" /> Como Avaliar Empresas e Fundos?</h2>
                    <p>Para avaliar empresas ou fundos, é essencial usar fontes confiáveis como o site de Relações com Investidores (RI) da empresa ou plataformas especializadas,
                        como o Investidor10.
                        Existem vários indicadores importantes a serem considerados, como:</p>
                    <ul className="blog-list">
                        <li><strong>P/L (Preço/Lucro):</strong> Relação entre o preço da ação e o lucro por ação.</li>
                        <li><strong>EV/EBITDA (Valor da Empresa/EBITDA):</strong> Mede o valor da empresa em relação ao seu lucro antes de juros, impostos, depreciação e amortização.</li>
                        <li><strong>ROI (Retorno sobre Investimento):</strong> Indica a rentabilidade do investimento.</li>
                        <li><strong>ROE (Retorno sobre o Patrimônio):</strong> Mede a eficiência da empresa em gerar lucros a partir do patrimônio líquido.</li>
                        <li><strong>Margem Líquida:</strong> Percentual do lucro líquido em relação à receita total.</li>
                        <li><strong>P/VPA (Preço/Valor Patrimonial):</strong> Relaciona o preço da ação com o valor patrimonial por ação.</li>

                        <li><strong>Dividendo por Ação (DPA):</strong> Mede a quantia de dividendos pagos aos acionistas por cada ação.</li>
                        <li><strong>Dividend Yield:</strong>Relação entre os dividendos pagos por ação e o preço da ação. Indica o retorno do investimento via dividendos.</li>
                        <li><strong>Beta:</strong>Mede a volatilidade da ação em relação ao mercado. Um beta maior que 1 indica que a ação é mais volátil que o mercado, e um beta menor que 1 indica que a ação é menos volátil.</li>
                        <li><strong>Liquidez Corrente:</strong>Mede a capacidade da empresa em pagar suas dívidas de curto prazo com seus ativos de curto prazo.</li>
                        <li><strong>Payout Ratio:</strong>Percentual dos lucros distribuídos como dividendos aos acionistas.</li>

                    </ul>
                </div>

                <div className="blog-section">
                    <h2 className="section-title"><FaUniversity className="icon" /> Tipos de Investimentos</h2>
                    <h3>1. Renda Fixa</h3>
                    <ul className="blog-list">
                        <li><strong>Tesouro Direto:</strong> Títulos emitidos pelo governo.</li>
                        <li><strong>CDB:</strong> Títulos emitidos por bancos.</li>
                        <li><strong>LCI e LCA:</strong> Investimentos isentos de imposto de renda.</li>
                    </ul>

                    <h3>2. Renda Variável</h3>
                    <ul className="blog-list">
                        <li><strong>Ações:</strong>Participação em empresas listadas na bolsa de valores a B3. "Compramos pelo código exemplo Banco do Brasil: 'BBAS3'."</li>
                        <li><strong>Fundos Imobiliários:</strong>Investimentos em imóveis listados na bolsa de valores a B3. "São escritórios, shoppings, galpões logísticos, entre outras modalidades. Normalmente pagam mensalmente."</li>
                        <strong>Lembrete:</strong><span>Quando você compra ações, está adquirindo uma participação na empresa. Isso significa que você tem direito a uma parte dos lucros, conhecidos como dividendos. Quanto mais ações você possui, maior será sua participação nos lucros da empresa.</span>
                    </ul>

                    <h3>3. Fundos de Investimento</h3>
                    <ul className="blog-list">
                        <li><strong>Fundos Multimercado:</strong> Diversificação em vários tipos de ativos.</li>
                        <li><strong>Fundos de Ações:</strong> Investimento em um conjunto de ações selecionadas por gestores.</li>
                    </ul>

                    <h3>4. Investimentos Alternativos:</h3>
                    <ul className="blog-list">
                        <li><strong>Criptomoedas:</strong> Ativos digitais como Bitcoin e Ethereum.</li>
                        <li><strong>Ouro:</strong> Investimento em metais preciosos.</li>
                    </ul>
                </div>

                <div className="blog-section">
                    <h2 className="section-title"><FaCogs className="icon" /> Método BEST</h2>
                    <p>Estratégia desenvolvida por Luiz Barsi Filho que se concentra em setores essenciais:</p>
                    <ul className="blog-list">
                        <li><strong>Bancos:</strong> Itaú, Bradesco, Banco do Brasil, etc.</li>
                        <li><strong>Energia:</strong> Empresas de geração e distribuição de energia como Petrobras, Eletrobras, Taesa, etc.</li>
                        <li><strong>Saneamento:</strong> Sanepar, Copasa, etc.</li>
                        <li><strong>Seguros:</strong> Banco do Brasil Seguros, Caixa Seguridade, Porto Seguro, etc.</li>
                        <li><strong>Telecomunicações:</strong> Vivo, Tim, Oi, etc.</li>
                    </ul>
                </div>

                <div className="blog-section">
                    <h2 className="section-title"><FaLightbulb className="icon" /> Dicas para Iniciantes</h2>
                    <ol className="blog-list">
                        <li><strong>Eduque-se constantemente:</strong>Aprenda sobre diferentes tipos de investimentos e mantenha-se atualizado.</li>
                        <li><strong>Diversifique seus investimentos:</strong>Espalhe seus investimentos para reduzir riscos.</li>
                        <li><strong>Tenha paciência:</strong>Investir é uma maratona, não uma corrida de 100 metros.</li>
                        <li><strong>Use ferramentas de planejamento:</strong>Utilize planilhas, aplicativos e outras ferramentas para monitorar seus investimentos.</li>
                    </ol>
                    <p>Comece a investir agora mesmo e transforme suas finanças! Com conhecimento e disciplina, você pode alcançar a estabilidade e o crescimento financeiro que deseja.</p>
                </div>
            </div>
        </HelmetProvider>
    );
}

export default Investimento;
